import { ArrowDownRight, ArrowUpRight } from "lucide-react";

export function TitleHeading({ title, children, className, Icon, ...props }) {
  return (
    <h1
      className={`text-xl font-bold flex items-center gap-1 ${className}`}
      {...props}
    >
      {" "}
      {Icon && <Icon />} {children ? children : title}
    </h1>
  );
}



// export function KPI({
//   icon: Icon,
//   label,
//   value,
//   sublabel,
//   stateLable,
//   positive,
//   positiveIcon = true,
//   onClick = () => {},
//   tag: Tag,
//   isTag = false,
//   extraClass,
// }) {
//   const extraClasses = {
//     red: "border-l-[4px] border-l-[#ef4444] bg-[linear-gradient(to_right,#fef2f2_0%,white_20%)]",
//     green:
//       "border-l-[4px] border-l-[#10b981] bg-[linear-gradient(to_right,#ecfdf5_0%,white_20%)]",
//     yellow:
//       "border-l-[4px] border-l-[#f59e0b] bg-[linear-gradient(to_right,#fffbeb_0%,white_20%)]",
//     theme: "border-l-[4px] border-l-[#0B54FF]",
//   };
//   const extraTextClasses = {
//     red: "!text-[#ef4444]",
//     green: "!text-[#10b981]",
//     yellow: "!text-[#f59e0b]",
//     theme: "!border-b-[2px] border-b-[#f2f3f5]",
//   };
//   // border-bottom: 2px solid #f2f3f5;
//   return (
//     <div
//       className={`bg-white border border-[#E1E4EA] shadow rounded-[14px] p-4 hover:shadow-md transition cursor-pointer ${
//         extraClass ? extraClasses[extraClass] : ""
//       }`}
//       onClick={onClick}
//     >
//       <div className="flex items-center justify-between">
//         <span className="text-[13px] text-[#6b7280] font-[500]">{label}</span>
//         <Icon className="h-5 w-5 text-gray-400" />
//       </div>
//       <div
//         className={`mt-2 text-[32px] text-[#1a1a2e] font-bold flex items-center justify-between gap-2 py-[10px] ${
//           extraClass ? extraTextClasses[extraClass] : ""
//         }`}
//       >
//         {typeof value == "string" ? value : Math.round(value)}
//         {/* {value} */}
//         {positive != null && (
//           <span
//             className={`flex items-center text-xs px-2 py-0.5 rounded-full ${
//               positive
//                 ? "bg-green-100 text-green-700"
//                 : "bg-red-100 text-red-700"
//             }`}
//           >
//             {positiveIcon ? (
//               positive ? (
//                 <ArrowUpRight className="h-3 w-3 mr-1" />
//               ) : (
//                 <ArrowDownRight className="h-3 w-3 mr-1" />
//               )
//             ) : null}
//             {stateLable}
//           </span>
//         )}
//         {isTag && <Tag />}
//       </div>
//       <div className="text-[12px] text-[#9ca3af] mt-[6px]">{sublabel}</div>
//     </div>
//   );
// }

export function KPI({ Status, className = "", icon: Icon, label, value, sublabel, stateLable, positive, positiveIcon = true, onClick = () => { }, tag: Tag, isTag = false, extraClass }) {
  const extraClasses = {
    red: "border-l-[4px] border-l-[#ef4444] bg-[linear-gradient(to_right,#fef2f2_0%,white_20%)]",
    green: "border-l-[4px] border-l-[#10b981] bg-[linear-gradient(to_right,#ecfdf5_0%,white_20%)]",
    yellow: "border-l-[4px] border-l-[#f59e0b] bg-[linear-gradient(to_right,#fffbeb_0%,white_20%)]",
    theme: "border-l-[4px] border-l-[#0B54FF]"
  }
  const extraTextClasses = {
    red: "!text-[#ef4444]",
    green: "!text-[#10b981]",
    yellow: "!text-[#f59e0b]",
    theme: "!border-b-[2px] border-b-[#f2f3f5]"
  }
  // border-bottom: 2px solid #f2f3f5;

  const wordCurrencies = ["pkr", "usd", "eur"];
  const symbolCurrencies = ["$"];

  const getMatchedCurrency = (value) => {
    if (typeof value !== "string") return null;

    for (const c of wordCurrencies) {
      if (new RegExp(`\\b${c}\\b`, "i").test(value)) return c;
    }

    for (const s of symbolCurrencies) {
      if (value.includes(s)) return s;
    }

    return null;
  };
  const currency = getMatchedCurrency(value);

  // console.log("currency", currency);
  // console.log("value", value)

  return (
    <div className={`bg-white border border-[#E1E4EA] ${className} shadow rounded-[14px] p-4 hover:shadow-md transition cursor-pointer ${extraClass ? extraClasses[extraClass] : ""}`} onClick={onClick}>

      <div className="flex flex-col gap-3">
        <div className="flex items-center justify-between">
          <span className="text-[13px] text-[#6b7280] font-[500]">{label}</span>
          {Icon ? <Icon className="h-5 w-5 text-gray-400" /> : Status ? Status : null}
        </div>
      </div>


      <div className={`mt-2 text-[32px] text-[#1a1a2e] font-bold flex items-center justify-between gap-2 py-[10px] ${extraClass ? extraTextClasses[extraClass] : ""}`}>
        {/* {value?.toString()?.toLowerCase()?.includes("pkr") ?
          <span>
            <span className='text-[18px] font-[500] opacity-70 pr-[2px]'>PKR</span>
            {value?.toString()?.replaceAll("PKR", "")}
          </span>
          :
          value
        } */}

        {/* {typeof value === "string" && /pkr/i.test(value) ? (
          <span>
            <span className="text-[18px] font-[500] opacity-70 pr-[2px]">PKR </span>
            {value.replace(/pkr/gi, "").trim()}
          </span>
        ) : (
          value
        )} */}

        {currency ? (
          <span>
            <span className="text-[18px] font-[500] opacity-70 pr-[2px] uppercase">
              {currency}
            </span>
            {value.replaceAll(currency, "").trim()}
          </span>
        ) : (
          value
        )}

        {positive != null && (
          <span
            className={`flex items-center text-xs px-2 py-0.5 rounded-full ${positive
              ? "bg-green-100 text-green-700"
              : "bg-red-100 text-red-700"
              }`}
          >

            {
              positiveIcon ? (
                positive ? (
                  <ArrowUpRight className="h-3 w-3 mr-1" />
                ) : (
                  <ArrowDownRight className="h-3 w-3 mr-1" />
                )
              ) : null
            }
            {stateLable}
          </span>
        )}
        {isTag &&
          <Tag />
        }
      </div>

      <div className="text-[12px] text-[#9ca3af] mt-[6px]">{sublabel}</div>
    </div>
  );
}


export function StatCardNew({ icon: Icon, iconBgColor, value, maxValue, label, percentage, trend = "", svg = "", heading, HeadingIcon, type }) {
  return (
    <div className="bg-white rounded-[10px]  py-5 px-[15px] hover:shadow-md transition-shadow border border-[#E1E4EA] w-full h-full">
      <div className="flex flex-col justify-between gap-3 w-full h-full">
        <div className="flex flex-col gap-[20px]">

          {type == "main" ?
            <h3 className="text-[14px] font-medium text-[#0E121B] flex items-center gap-[8px]">
              <div className={`max-w-max p-[5px] bg-[${iconBgColor}] rounded-[5px] flex items-center justify-center`} style={{ background: iconBgColor }}>
                {Icon ? (<Icon className={`w-6 h-6 !text-[#fff]`} />) : svg ? (svg) : null}
              </div>
              {heading}
            </h3>
            :
            <h3 className="text-[14px] font-medium text-[#0E121B] flex items-center gap-[8px]">
              {HeadingIcon ? <HeadingIcon /> : null}
              {heading}
            </h3>
          }


          <div className="flex flex-col gap-[10px]">
            {type == "main" ?
              <div className="flex items-center justify-between">
                <span className="text-[#0E121B] text-[26px] font-semibold">{value}</span>
              </div>
              :
              <div className="flex items-center justify-between">
                {Icon ? (<Icon className={`w-6 h-6 !text-[#fff]`} />) : svg ? (svg) : null}
                <span className="text-[#0E121B] text-[26px] font-semibold">{value}</span>
              </div>
            }
            {/* <p className="text-xs text-[#999] font-medium   leading-tight">{label}</p> */}
          </div>
        </div>

        <div className="space-y-3">
          <div className="bg-[#E1E4EA]  h-[1px]"></div>

          <div className="flex items-center space-x-1  ">
            {trend === "up" ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  d="M8.46362 13.3333V2.66666M8.46362 2.66666L4.46362 6.66666M8.46362 2.66666L12.4636 6.66666"
                  stroke="#84CC16"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  d="M8.46368 2.66665L8.46368 13.3333M8.46368 13.3333L12.4637 9.33331M8.46368 13.3333L4.46368 9.33331"
                  stroke="#FF4040"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            )}
            <span className={`text-xs font-medium text-[#0E121B] `}>
              {percentage}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export const Card = ({ className = "", children }) => (
  <div
    className={`w-full border border-[#E1E4EA] shadow rounded-[14px] flex flex-col bg-white 1darkbg-slate-900 ${className}`}
  >
    {children}
  </div>
);
export const CardHeader = ({ className = "", children }) => (
  <div
    className={`p-4 md:p-5 border-b border-slate-100 1darkborder-slate-800 ${className}`}
  >
    {children}
  </div>
);
export const CardTitle = ({ className = "", children }) => (
  <h3
    className={`text-lg md:text-xl font-semibold tracking-tight ${className}`}
  >
    {children}
  </h3>
);
export const CardContent = ({ className = "", children }) => (
  <div className={`p-4 md:p-5 w-full h-full ${className}`}>{children}</div>
);
